import React from 'react'
import './Style/Product.css'
import {product} from './modal'
import ReactHTMLTableToExcel from "react-html-table-to-excel";


function Product({data,DateDay}) {
  return <div className="table">
    <div className='product-info'>
      <p> Date: <span> {DateDay} </span>  </p>
      <p> Invoice Number: <span> {product.productNumber} </span> </p>
    </div>
  <table id="table-invoice">
    <thead>
        <tr>
            <th className="th-first">Description</th>
            <th className="th-center">Price</th>
            <th className="th-center">QTY</th>
            <th className="th-end">Total</th>
        </tr>
    </thead>

    {data.map((item,key)=>(
        <tr key={key}>
              <td className='td-first'>{item.description} </td>
              <td className='td-center'> ${item.price} </td>
              <td className='td-center'> {item.qty} </td>
              <td className='td-end'> ${item.price * item.qty} </td>
        </tr>
    ))}
  </table>

  <div className='button-export-to-exsel'>
      <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-invoice"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Print To Excel"
      />
  </div>


</div>
}

export default Product